import { useState } from "react";
import { Button, Modal } from "antd";
// import requestFetch from "../../../Fetch/requestFetch";
import CategotyUpdate from "./CategotyUpdate";
import useCategory from "Provider/Category/useCategory";

const CategoryUpdateModal = ({ GetCategory, open, setOpen, isvalue, form }) => {
  const [loading, setLoading] = useState(false);
  const { categoryUpdate } = useCategory();
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
    form.setFieldsValue({
      name: "",
      id: "",
    });
  };

  return (
    <>
      <Modal
        open={open}
        title="Toifalari nimini o'zgartirish oynasi"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="primary" danger onClick={handleCancel}>
            Yopish
          </Button>,
          <Button
            key="backс"
            type="primary"
            danger
            onClick={() => form.resetFields()}
          >
            O'chirish
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            O'zgartirish
          </Button>,
        ]}
      >
        <CategotyUpdate
          handleFinesh={categoryUpdate}
          form={form}
          isvalue={isvalue}
        />
      </Modal>
    </>
  );
};
export default CategoryUpdateModal;
